export default __webpack_public_path__ + "static/media/pi-ico.4f7fa088.svg";